import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Hero from "../../components/homepage/hero/hero";
import PopularInternships from "../../components/homepage/popularInternships/internships";
import TopCategories from "../../components/homepage/topCategories/categories";
import WhyUs from "../../components/homepage/whyUs/whyUs";
import Testimonials from "../../components/homepage/testimonials/testimonials";
import HowItWorks from "../../components/homepage/howItWorks/working";
import Contact from "../../components/contactSection/contact";
import { contactLink } from "../../common/routes";

function Homepage() {
  const ContactText =
    "Talk to our counsellor and choose the best carrier path for yourself.";
  const ContactButtonText = "Contact Us";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <Hero />
      <PopularInternships />
      <TopCategories />
      <WhyUs />
      <Testimonials />
      <HowItWorks />
      <Contact
        text={ContactText}
        buttonText={ContactButtonText}
        url={contactLink}
        colorBackground={"#F8FBFE"}
      />
    </Box>
  );
}

export default Homepage;
